import React from "react";
import { Search } from "./Search";
import Perspective from "perspective-transform";

const COORDS = [[87, 396,256, 411, 80, 494,  248, 506 ], 
[278,406,447,406, 283,509,451,503],
[177,514,272,518,157,591,268,599],
[269,278,300,280,265,328,295,327]]
;

const [WIDTH, HEIGHT] = [535.0, 683.0];
const ALBUM_SIZE = 512;
const CLASS_NAMES = ["one", "two", "three", "four"];

const Main = () => {
  const [state, setState] = React.useState({
    type: "",
    isActive: false,
    items: {},
  });

  const ref = React.useRef();
  const [count, setCount] = React.useState(0);
  const width = (ref.current && ref.current.width) || 0;

  React.useEffect(() => {
    if (!width) {
      setTimeout(() => {
        setCount(count + 1);
      }, 10);
    }
  }, [count]);
  const scale = width ? width / WIDTH : 1.0;

  let matrices = COORDS.map(
    dest =>
      Perspective(
        [0, 0, ALBUM_SIZE, 0, 0, ALBUM_SIZE, ALBUM_SIZE, ALBUM_SIZE],
        dest.map(x => x * scale)
      ).coeffs
  ).map(x => [x[0], x[3], 0, x[6], x[1], x[4], 0, x[7], 0, 0, 1, 0, x[2], x[5], 0, x[8]].join(','));

  const updateDiv = (el) => {
    setState((prevState) => {
      console.log(prevState)
      let items = { ...prevState.items };
      items = { ...items, [prevState.type]: { ...el } };
      return { ...prevState, items, isActive: false };
    });
  };
  const { items } = state;
  
  return (
    <div className="Main">
      
      {Object.keys(items).length ? <div className="recommendationbox">
        {items.books && <p>Book : {items.books.name}</p>}
        {items.shows && <p>Show : {items.shows.name}</p>}
        {items.movies && <p>Movie : {items.movies.name}</p>}
        {items.songs && <p>Song : {items.songs.name}</p>}
        </div> : "" }
      <img id="mainimage" src="/main.jpg" ref={ref}/>
      <div
        className="demo book"
        style={{
          backgroundImage: `url(${items.books && items.books.img})`,
          transform: `matrix3d(${matrices[2]})`,
          transformOrigin: '0px 0px 0px',
          borderWidth: '15px' ,
          width: `${ALBUM_SIZE}px`,
          height: `${ALBUM_SIZE}px`
        }}
        onClick={() => {
          setState((ps)=> ({...ps,  type: "books", isActive: true }));
        }}
      >
        {items.books ? items.books.name : <img src="/search.svg"/>}
      </div>
      <div
        className="demo show"
        style={{
          backgroundImage: `url(${items.shows && items.shows.img})`,
          transform: `matrix3d(${matrices[1]})`,
          transformOrigin: '0px 0px 0px',
          borderWidth: '15px' ,
          width: `${ALBUM_SIZE}px`,
          height: `${ALBUM_SIZE}px`
        }}
        onClick={() => {
          setState((ps)=> ({...ps,  type: "shows", isActive: true }));
        }}
      >
        {items.shows ? items.shows.name : <img src="/search.svg"/>}
      </div>
      <div
        className="demo song"
        
        style={{
          backgroundImage: `url(${items.songs && items.songs.img})`,
          transform: `matrix3d(${matrices[3]})`,
          transformOrigin: '0px 0px 0px',
          borderWidth: '15px' ,
          width: `${ALBUM_SIZE}px`,
          height: `${ALBUM_SIZE}px`
        }}
        onClick={() => {
          setState((ps)=> ({...ps,  type: "songs", isActive: true }));
        }}
      >
        {items.songs ? items.songs.name : <img src="/search.svg"/>}
      </div>
      <div
        className="demo movie"
        style={{
          backgroundImage: `url(${items.movies && items.movies.img})`,
          transform: `matrix3d(${matrices[0]})`,
          transformOrigin: '0px 0px 0px',
          borderWidth: '15px' ,
          width: `${ALBUM_SIZE}px`,
          height: `${ALBUM_SIZE}px`
        }}
        onClick={() => {
          setState((ps)=> ({...ps,  type: "movies", isActive: true }));
        }}
      >
        {items.movies ? items.movies.name : <img src="/search.svg"/>}
      </div>
      {state.isActive && <Search type={state.type} updateState={updateDiv} />}
    </div>
  );
};

export default Main;
